import Colors from '../../../../shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const NotAllowedChannelText = styled.span<React.CSSProperties>`
  color: ${Colors['text']};
  font-family: ${Fonts['regular']};
  font-size: ${40 * Screen.widthRatio}px;
`;

export default NotAllowedChannelText;
